const MODELS = {
  Ionian: ["Whole", "Whole", "Half", "Whole", "Whole", "Whole", "Half"],
  Dorian: ["Whole", "Half", "Whole", "Whole", "Whole", "Half", "Whole"],
  Phrygian: ["Half", "Whole", "Whole", "Whole", "Half", "Whole", "Whole"],
  Lydian: ["Whole", "Whole", "Whole", "Half", "Whole", "Whole", "Half"],
  Mixolydian: ["Whole", "Whole", "Half", "Whole", "Whole", "Half", "Whole"],
  Aeolian: ["Whole", "Half", "Whole", "Whole", "Half", "Whole", "Whole"],
  Locrian: ["Half", "Whole", "Whole", "Half", "Whole", "Whole", "Whole"],
};

export default MODELS;
